import BaseListController from "./base_list_controller"
import { Turbo } from "@hotwired/turbo-rails"
import { Controller } from "@hotwired/stimulus"

export default class extends BaseListController {
  static targets = ["searchInput"]

  connect() {
    super.connect()
    this.search = this.debounce(this.search.bind(this), 300)
  }

  search() {
    const query = this.searchInputTarget.value
    const url = new URL(window.location)
    url.searchParams.set('query', query)
    
    fetch(url, {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html'
      }
    })
    .then(response => response.text())
    .then(html => Turbo.renderStreamMessage(html))
  }

  loginAs(event) {
    const userId = event.currentTarget.dataset.teamListUserIdParam
    const userName = event.currentTarget.dataset.teamListUserNameParam
    
    if (confirm(`Are you sure you want to login as ${userName}?`)) {
      // Create a form element
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = `/team/${userId}/login_as`
      
      // Add CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]').content
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
      
      // Append form to body and submit
      document.body.appendChild(form)
      form.submit()
    }
  }

  debounce(func, delay) {
    let timeoutId
    return function (...args) {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => func.apply(this, args), delay)
    }
  }

  editMember(event) {
    // Don't trigger edit if clicking on dropdown or its children
    if (event.target.closest('.dropdown')) {
      return
    }
    
    const memberId = event.currentTarget.dataset.teamListMemberIdParam
    const editPath = `/team/${memberId}/edit`
    Turbo.visit(editPath)
  }
}
